import React from 'react';
import BreakPoints from '../styles/breakpoints';
import Events from 'material-ui/utils/events';
import MediaQueries from '../utils/style/mediaQueries';

const StyleDecorator = (ChildComponent) => {
	class Decorator extends React.Component {
		state = {
			mediaQueries: new MediaQueries(this.findCurrentBreakPoint().size),
		};

		componentWillMount() {
			this.bindResize();
			this.updateDeviceSize();
		}

		componentDidUpdate(prevProps, prevState) {
			if (this.state.mediaQueries.getCurrentDeviceSize() !== prevState.mediaQueries.getCurrentDeviceSize()) {
				// console.info('Set device size to ' + // eslint-disable-line no-console
				// 	this.state.mediaQueries.getCurrentBreakPointName() + // eslint-disable-line no-console
				// 	'(' + this.state.mediaQueries.getCurrentDeviceSize() + ')'); // eslint-disable-line no-console
			}
		}

		componentWillUnmount() {
			this.unbindResize();
		}

		findCurrentBreakPoint() {
			const width = window.innerWidth;
			let currentBreakPoint = {
				size: width,
			};
			// eslint-disable-next-line no-restricted-syntax
			for (const breakPoint in BreakPoints) {
				if (BreakPoints.hasOwnProperty(breakPoint)) {
					if (width >= BreakPoints[breakPoint]) {
						currentBreakPoint = {
							size: BreakPoints[breakPoint],
							name: breakPoint,
						};
					}
				}
			}

			return currentBreakPoint;
		}

		updateDeviceSize = () => {
			const currentBreakPointSize = this.state.mediaQueries.getCurrentDeviceSize();
			const newBreakPoint = this.findCurrentBreakPoint();

			if (currentBreakPointSize !== newBreakPoint.size) {
				this.setState({ mediaQueries: new MediaQueries(newBreakPoint.size) });
			}
		};

		bindResize() {
			Events.on(window, 'resize', this.updateDeviceSize);
		}

		unbindResize() {
			Events.off(window, 'resize', this.updateDeviceSize);
		}

		render() {
			return (
				<ChildComponent
					mediaQueries={this.state.mediaQueries}
					{...this.props}
				/>
			);
		}
	}

	return Decorator;
};

export default StyleDecorator;



// WEBPACK FOOTER //
// ./src/components/StyleDecorator.js